import Storage from 'views/assets/scripts/services/storage/storage'

const storage = new Storage('sessionStorage')
const prescriptionFollowsStateLivingTime = 24 * 60 * 60 * 1000 // 1 day

export const changePrescriptionFollowsInSession = () => {
  if (storage.get('prescriptionFollows')) {
    storage.set('prescriptionFollows', false)
    storage.remove('prescriptionFollowsTimestamp')
  } else {
    storage.set('prescriptionFollows', true)
    storage.set('prescriptionFollowsTimestamp', new Date().getTime())
  }
}

const isPrescriptionFollowsTimestampValid = () => {
  const prescriptionFollowsTimestamp = storage.get(
    'prescriptionFollowsTimestamp'
  )
  return (
    prescriptionFollowsTimestamp &&
    new Date().getTime() - prescriptionFollowsTimestamp <
      prescriptionFollowsStateLivingTime
  )
}

export const setInitialPrescriptionFollowsInSession = () => {
  if (!isPrescriptionFollowsTimestampValid()) {
    storage.set('prescriptionFollows', false)
    storage.remove('prescriptionFollowsTimestamp')
  } else if (storage.get('prescriptionFollows')) {
    storage.set('prescriptionFollows', true)
  } else {
    storage.set('prescriptionFollows', false)
  }
}

export const getPrescriptionFollowsStatus = () => {
  return (
    storage.get('prescriptionFollows') && isPrescriptionFollowsTimestampValid()
  )
}

export const removePrescriptionFollowsInSession = () => {
  storage.remove('prescriptionFollows')
  storage.remove('prescriptionFollowsTimestamp')
}
